import * as THREE from "three";
import { Map } from "./3D/ENTITIES/Map";
import { Office } from "./3D/ENTITIES/Office";
import { Magnifier } from "./3D/ENTITIES/Magnifier";
import { Pendrive } from "./3D/ENTITIES/Pendrive";
import { Others } from "./3D/ENTITIES/Others";
import { Chart } from "./3D/ENTITIES/Chart";

export class Ui {

  constructor(store) {
    this.store = store;
    this.group = new THREE.Group();
    this.store.world.add(this.group);
    this.map = new Map(this.store, this.group);
    this.magnifier = new Magnifier(this.store, this.group);
    this.pendrive = new Pendrive(this.store, this.group);
    this.others = new Others(this.store, this.group);
     this.store.others = this.others;
    this.chart = new Chart(this.store, this.group);
    this.offices = [];
  }

  spawnOffices(){
     
    this.store.database.districts.forEach((office, index) => {
      const spawnOffice = new Office(this.store, this.group, office.name, index, office.district);
      spawnOffice.group.position.set(
        Number(import.meta.env[`VITE_OFFICE_${office.name}_X`]),
        Number(import.meta.env[`VITE_OFFICE_${office.name}_Y`]),
        Number(import.meta.env[`VITE_OFFICE_${office.name}_Z`]))
        this.offices.push(spawnOffice);
      });
  }

  showSelectedOffice() {
    let selectedOffice = null;
    if(this.store.level.cityCaller === 'OFFICE'){selectedOffice = this.store.level.selectedOffice;
    }else if(this.store.level.cityCaller === 'USER'){selectedOffice = this.store.level.selectedOffice.label;}
    
    this.offices.forEach(office => {office.group.visible = false;});
    const office = this.offices.find(office => office.label === selectedOffice);
    if (!office) return;
    office.group.visible = true;
    office.model.visible = true;
    office.nameLabel.visible = true;
    office.colleagueGroup.visible = true;
    // Visszaállítjuk a normál BASE pozícióra
    office.group.position.y = 0;
    office.targetY = 1;
    this.group.visible = true;
  }

  showAllOffices() {
    this.offices.forEach(office => {
        office.group.visible = true;  
        office.model.visible = true;
        office.nameLabel.visible = true;
        office.colleagueGroup.visible = true;
        office.targetY = 0;
    });
  }

  update(delta) {
    if(!this.store.config.officesSpawned && this.store.level.levelName !== 'CHARTCITY'){
      this.spawnOffices();
      this.store.config.officesSpawned = true;
    }
    this.others.update(delta)
    this.offices.forEach((office) => {office.update(delta);});
    this.map.update(delta);
    this.store.levelController.update(delta);
    
  }

  clearOffices() {
      this.offices.forEach(office => {office.dispose();});
      this.offices = [];
      this.store.config.officesSpawned = false;
  }


}